import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { BrowserModule } from '@angular/platform-browser';
import { MessageInputComponent } from './message-input/message-input.component';
import { MessagesListComponent } from './messages-list/messages-list.component';
import { OptionsContentComponent } from './messages-list/options-content.component';
import { TextContentComponent } from './messages-list/text-content.component';
import { SerprobotsConfig } from './serprobots-config';
import { SERPROBOTS_CONFIG_TOKEN } from './serprobots-config.token';
import { FormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { HeaderComponent } from './header/header.component';
import { AssesmentComponent } from './assesment/assesment.component';
import { ImageComponent } from './messages-list/image-content.component';
import { SafePipe } from './pipes/sanitizer.pipe';


@NgModule({
  declarations: [
    MessagesListComponent,
    TextContentComponent,
    OptionsContentComponent,
    MessageInputComponent,
    HeaderComponent,
    AssesmentComponent,
    ImageComponent,
    SafePipe
  ],
  imports: [
    FormsModule,
    BrowserModule,
    HttpClientModule,
    MatToolbarModule,
    MatCardModule,
    MatMenuModule,
    MatSelectModule,
    MatListModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule,
    FlexLayoutModule
  ],
  exports: [
    MessagesListComponent,
    TextContentComponent,
    OptionsContentComponent,
    MessageInputComponent,
    HeaderComponent,
    AssesmentComponent,
    ImageComponent,
    SafePipe
  ]
})
export class SerprobotsModule {

  public static forRoot(config: SerprobotsConfig): ModuleWithProviders<SerprobotsModule> {
    return {
      ngModule: SerprobotsModule,
      providers: [{ provide: SERPROBOTS_CONFIG_TOKEN, useValue: config }]
    };
  }

 }
